import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faHome, faCrown, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faHome);
library.add(faCrown);
library.add(faSave);
Vue.component("font-awesome-icon", FontAwesomeIcon);
